import type { RootState } from 'src/state';

import debug from 'debug';

import * as ActionTypes from './action-types';

declare let window: {
  cello: any;
  CelloAttribution: any;
};

const log = debug('lumi:state:cello:actions');

export function cello_init(
  productId: string,
  token: string,
  language: string,
  firstName: string,
  lastName: string,
  email: string,
  fullName: string
) {
  return async (dispatch: any, getState: () => RootState) => {
    log('cello_init called with', {
      productId,
      token,
      language,
      firstName,
      lastName,
      email,
      fullName,
    });

    const ucc = await window.CelloAttribution('getUcc');
    dispatch({
      type: ActionTypes.CELLO_INIT,
      payload: {
        productId,
        token,
        language,
        firstName,
        lastName,
        email,
        fullName,
        ucc,
      },
    });

    window.cello = window.cello || { cmd: [] };
    window.cello.cmd.push(async (cello: any) => {
      await cello.boot({
        productId,
        token,
        language,
        productUserDetails: {
          firstName,
          lastName,
          email,
          fullName,
        },
      });
    });

    dispatch({
      type: ActionTypes.CELLO_INIT_SUCCESS,
      payload: {
        productId,
        token,
        language,
        firstName,
        lastName,
        email,
        fullName,
        ucc,
      },
    });
  };
}
